import { useState } from "react";
import { Copy, Check, Pencil, Trash2, CalendarDays } from "lucide-react";
import { periodLabel } from "@/components/DateFilter";
import { toast } from "sonner";
import { copyText } from "@/lib/api";
import { QR } from "@/constants/testIds";

export const TemplateCard = ({ tpl, categoryName, isAdmin, onEdit, onDelete, index }) => {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    const ok = await copyText(tpl.content);
    if (ok) {
      setCopied(true);
      toast.success("Jawaban disalin", { description: tpl.title });
      setTimeout(() => setCopied(false), 1600);
    } else {
      toast.error("Gagal menyalin teks");
    }
  };

  return (
    <article data-testid={QR.card} style={{ animationDelay: `${Math.min(index, 12) * 35}ms` }}
      className="fade-up group flex h-full flex-col rounded-lg border border-slate-200 bg-white p-5 transition-[transform,box-shadow,border-color] duration-200 hover:-translate-y-1 hover:border-slate-300 hover:shadow-md">
      <div className="flex items-start justify-between gap-3">
        <span className="rounded-full bg-sky-50 px-2.5 py-1 text-[11px] font-medium text-sky-700">{categoryName || "Tanpa kategori"}</span>
        {isAdmin && (
          <div className="flex gap-1 opacity-100 lg:opacity-0 lg:group-hover:opacity-100 transition-opacity">
            <button onClick={() => onEdit(tpl)} className="rounded-md p-1.5 text-slate-500 hover:bg-slate-100 hover:text-slate-900" aria-label="Edit" data-testid={QR.editButton}>
              <Pencil className="h-3.5 w-3.5" />
            </button>
            <button onClick={() => onDelete(tpl)} className="rounded-md p-1.5 text-slate-500 hover:bg-red-50 hover:text-red-600" aria-label="Hapus" data-testid={QR.deleteButton}>
              <Trash2 className="h-3.5 w-3.5" />
            </button>
          </div>
        )}
      </div>
      {periodLabel(tpl) && <p className="mt-3 inline-flex items-center gap-1.5 text-xs font-medium text-slate-500" data-testid={QR.cardDate}><CalendarDays className="h-3.5 w-3.5" />{periodLabel(tpl)}</p>}
      <h3 className="font-heading mt-2 text-base font-semibold tracking-tight text-slate-900">{tpl.title}</h3>
      <p className="mt-2 flex-1 whitespace-pre-line text-sm leading-relaxed text-slate-600 line-clamp-6">{tpl.content}</p>
      {tpl.keywords?.length > 0 && (
        <div className="mt-4 flex flex-wrap gap-1.5">
          {tpl.keywords.map((k) => (
            <span key={k} className="rounded border border-slate-200 px-1.5 py-0.5 text-[11px] text-slate-500">#{k}</span>
          ))}
        </div>
      )}
      <button onClick={copy} data-testid={QR.copyButton}
        className={`mt-5 flex h-10 w-full items-center justify-center gap-2 rounded-full text-sm font-medium transition-colors ${copied ? "bg-emerald-500 text-white" : "bg-brand text-white hover:bg-brand-dark"}`}>
        {copied ? <Check className="h-4 w-4" /> : <Copy className="h-4 w-4" />}
        {copied ? "Tersalin" : "Salin Jawaban"}
      </button>
    </article>
  );
};
